<template>
  <v-select
    v-model="selected"
    :no-data-text="$t('reports.no_teams')"
    :placeholder="$isPaidTenant ? $t('reports.all_target_groups') : $t('reports.choose_target_group')"
    persistent-placeholder
    v-bind="$attrs"

  >
    <template v-slot:item="{item, on, attrs}">
      <v-list-item :class="`${isItemDisabled(item) ? 'grey lighten-3' : ''}`" v-bind="attrs"
                   @click="handleClickSurveyShare(item)">
        <v-list-item-action >
          <v-simple-checkbox :value="selected.includes(item.key)" @click.stop="handleClickSurveyShare(item)"/>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="isItemDisabled(item)">
          <plan-chip/>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import PlanChip from "@/components/Tenant/Reports/PlanChip";

export default {
  name: "SurveyShareSelector",
  components: {PlanChip},
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: this.value
    };
  },
  methods: {
    isItemDisabled(item) {
      if (!this.$isPaidTenant && this.selected.length >= 1 && !this.selected.includes(item.key)) {
        return true;
      }
      return false;
    },
    handleClickSurveyShare(item) {
      if (this.isItemDisabled(item)) {
        this.$showPlanNotification(this.$t('reports.selected_share_warning', [this.$nextPlan.name]));
        return;
      }
      if (this.selected.includes(item.key)) {
        this.selected = this.selected.filter(i => i !== item.key);
      } else {
        this.selected.push(item.key);
      }
    }
  },
  watch: {
    selected: {
      handler(value) {
        this.$emit("input", value);
      },
      deep: true
    },
    value: {
      handler(value) {
        this.selected = value;
      },
      deep: true
    }
  }
}
</script>

